<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4 class="mr-auto">{{$t('DERIVED')}}</h4>
      <div>
        <v-row class="pr-3">
          <v-col class="text-right p-0">
            <v-btn
              class="mt-0 mr-2"
              color="primary"
              @click="$router.push({ name: 'calculate' })"
              small
            >
              <v-icon light size="20px" left>calculate</v-icon>
              {{$t('LIST_FORMULAR')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <div class="body-room-sale">
        <div class="grid pb-0">
          <div class="grid-body">
            <v-progress-linear
              color="secondary"
              indeterminate
              rounded
              height="3"
              v-if="isLoading"
            ></v-progress-linear>

            <v-card-text>
              <v-row align="center">
                <v-col sm="4" class="pt-0 pb-0">
                  <label>{{$t("MASTER_PRODUCT")}}</label>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    :items="listProduce"
                    v-model="selectedProduce"
                    outlined
                    dense
                    chips
                    multiple
                    :placeholder="$t('ALL')"
                    @change="changeSearchCondition()"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0"  color="primary" 
                      v-bind="item.attrs"
                    :input-value="item.selected" close
                      @click:close="removeChips(index, selectedProduce); changeSearchCondition()"
                      >
                        <span style="max-width: 250px; overflow: hidden; text-overflow: ellipsis;">{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ selectedProduce.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="4" class="pt-0 pb-0">
                  <label>{{$t("SALE_CHANNEL")}}</label>
                  <v-select
                    item-text="text"
                    item-value="value"
                    :items="listOTA"
                    v-model="selectedOTA"
                    outlined
                    dense
                    @change="changeSearchCondition()"
                  >
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-select>
                </v-col>
                <!-- đây sẽ lưu trữ hạn chế -->
                <v-col sm="4" class="pt-0 pb-0">
                  <label>{{$t("RESTRICTION")}}</label>
                  <v-select
                    item-text="text"
                    item-value="value"
                    :items="listRestriction"
                    v-model="selectedRestriction"
                    outlined
                    multiple
                    dense
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, selectedRestriction);"
                      >
                        <span style="max-width: 250px; overflow: hidden; text-overflow: ellipsis;">{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ selectedRestriction.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <div class="view-table">
              <div class="max-height-table" :style="{ 'max-height': maxHeight + 'px' }">
                <table class="room-sale-table" v-if="isLoading == false">
                  <tr>
                    <td class="table-left">
                      <div class="table-left-content">
                        <table>
                          <thead>
                            <tr>
                              <th colspan="2">
                                <div class="header-wrapper calendar">
                                  <v-icon
                                    light
                                    left
                                    color="#003e94"
                                    size="40"
                                    @click="prevMonth()"
                                    >chevron_left</v-icon
                                  >
                                  <date-picker
                                    :model.sync="selectedDatePicker"
                                    :min="currentDatePicker"
                                    :max="maxDate"
                                    format="DD/MM/YYY"
                                    class="outlined"
                                    dense
                                    outlined
                                  />
                                  <v-icon
                                    light
                                    right
                                    color="#003e94"
                                    size="40"
                                    @click="nextMonth()"
                                    >chevron_right</v-icon
                                  >
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="dataMasterRate">
                            <template v-for="(room, i) in dataMasterRate">
                              <tr :key="'MroomRow1'+i">
                                <td class="room-row">
                                  <div class="body-wrapper justify-content-between">
                                    <div class="vertical-divider">
                                      <div class="font-weight-bold text-truncate" style="max-width: 270px;" :title=" room.roomTypeI18n.find(
                                            (x) => x.lang == defaultI18n
                                          ).name + ' - ' +  room.ratePlanI18n.find(
                                            (x) => x.lang == defaultI18n
                                          ).name + ' - ' + room.otaName">
                                        {{
                                          room.roomTypeI18n.find(
                                            (x) => x.lang == defaultI18n
                                          ).name
                                        }}
                                        -
                                        {{
                                          room.ratePlanI18n.find(
                                            (x) => x.lang == defaultI18n
                                          ).name
                                        }}
                                        -
                                        {{room.otaName}}
                                      </div>
                                      <div>
                                        <span class="txt-parent">M</span>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td class="room-row">
                                    <div class="body-wrapper d-flex justify-content-between border-right font-weight-bold text-truncate">
                                      <span class="pl-1">{{ $t("RATE")}}</span>
                                      <v-icon
                                          light
                                          size="18"
                                          color="#003e94"
                                          class="pr-1"
                                          @click="updatePrice(room)"
                                          >edit</v-icon
                                        >
                                    </div>
                                </td>
                              </tr>
                              <tr v-for="(restriction, idx1) in filterRestrictions" :key="'Mrestriction'+idx1">
                                <td class="border-right" :class="filterRestrictions.length - 1 > idx1 ? 'row-span' : ''"></td>
                                <td>
                                  <div class="body-wrapper d-flex justify-content-between border-right font-weight-bold text-truncate">
                                    <span class="pl-1">{{restriction.text}}</span>
                                    <i
                                      class="icon-edit text-primary fs-16"
                                      @click="updateRestriction(room, restriction.value)"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                              <template
                                v-if="room.children.length > 0"
                                v-for="(child, j1) in room.children"
                              >
                                <tr :key="'CroomRow1'+j1">
                                  <td>
                                    <div class="body-wrapper justify-content-between">
                                      <div class="vertical-divider">
                                        <span
                                          class="font-weight-bold pl-3 text-truncate d-inline-block" style="max-width: 270px;"
                                          :title=" child.roomTypeI18n.find(
                                              (x) => x.lang == defaultI18n
                                            ).name + ' - ' + child.ratePlanI18n.find(
                                              (x) => x.lang == defaultI18n
                                            ).name + ' - ' + child.otaName">{{
                                            child.roomTypeI18n.find(
                                              (x) => x.lang == defaultI18n
                                            ).name
                                          }}
                                          -
                                          {{
                                            child.ratePlanI18n.find(
                                              (x) => x.lang == defaultI18n
                                            ).name
                                          }}
                                          -
                                          {{child.otaName}}
                                          </span
                                        >
                                        <span class="txt-child-primary text-master-rate">C</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="body-wrapper d-flex justify-content-between border-right font-weight-bold text-truncate">
                                      <span class="pl-1">{{ $t("RATE")}}</span>
                                    </div>
                                  </td>
                                </tr>
                                <tr v-for="(restriction, idx1) in filterRestrictions" :key="'Crestriction'+idx1+'CroomRow1'+j1">
                                  <td class="border-right" :class="filterRestrictions.length - 1 > idx1 ? 'row-span' : ''"></td>
                                  <td>
                                    <div class="body-wrapper d-flex justify-content-between border-right font-weight-bold text-truncate">
                                      <span class="pl-1">{{restriction.text}}</span>
                                      <i
                                        class="icon-edit text-primary fs-16"
                                        @click="updateRestriction(child, restriction.value)"
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td class="table-right">
                      <div id="ngonquadi" class="table-right-content">
                        <table>
                          <thead>
                            <tr>
                              <template v-for="(item, i) in dateList">
                                <th :key="'R'+i" :class="{ 'weekend-header': item.isWeekend }">
                                  <div class="header-wrapper">
                                    <div
                                      class="date"
                                      v-html="formatDate(item.date)"
                                    ></div>
                                  </div>
                                </th>
                              </template>
                            </tr>
                          </thead>
                          <tbody v-if="dataMasterRate.length > 0">
                            <template v-for="(room, i) in dataMasterRate">
                              <tr :key="'RD'+i">
                                <td
                                  v-for="(avail, key) in dateList"
                                  :class="{ 'weekend-body': avail.isWeekend }"
                                  class="room-row"
                                  :key="'dateList'+key"
                                >
                                  <div class="body-wrapper special-price">
                                    <template
                                      v-if="
                                        room.roomRateSpecials.find(
                                          (x) => x.appliedDate == avail.date
                                        ) &&  room.roomRateSpecials.find(
                                          (x) => x.appliedDate == avail.date
                                        ).pricePax !== -1
                                      "
                                    >
                                      <div class="vertical-divider ">
                                        <span class="fs-12 font-weight-bold">
                                          {{
                                            numberFormat(
                                              room.roomRateSpecials.find(
                                                (x) => x.appliedDate == avail.date
                                              ).pricePax
                                            )
                                          }}
                                        </span>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <div
                                        class="vertical-divider px-4 fs-12"
                                      >
                                        {{
                                          numberFormat(
                                            room[formatDateOfWeekInPrice(avail.date)]
                                          )
                                        }}
                                      </div>
                                    </template>
                                  </div>
                                </td>
                              </tr>
                              <tr v-for="(restriction, idx1) in filterRestrictions" :key="'filterRestrictionsA'+idx1">
                                <td
                                  v-for="(avail, key) in dateList"
                                  :class="{ 'weekend-body': avail.isWeekend }"
                                  class="border-right"
                                  :key="key"
                                >
                                  <div class="text-center">
                                      <span v-if="(rowData = room.restrictionDTOS.find(e => e.appliedDate === avail.date))">
                                        <template v-if="['closed', 'closedOnArrival', 'closedOnDeparture'].includes(restriction.value)">
                                          <template v-if="rowData[restriction.value]">
                                            <i class="icon-Exit text-danger fs-18 font-weight-bold cursor-default"></i>
                                          </template>
                                          <template v-else>
                                          <i class="icon-check text-success fs-16 font-weight-bold cursor-default"></i>
                                          </template>
                                        </template>
                                        <template v-else>
                                          {{rowData[restriction.value] >= 0 ? rowData[restriction.value] : '-'}}
                                        </template>
                                      </span>
                                      <span v-else>-</span>
                                  </div>
                                </td>
                              </tr>
                              <template
                                v-if="room.children.length > 0"
                                v-for="(chid, j1) in room.children"
                              >
                                <tr :key="'RC'+j1">
                                  <td
                                    v-for="(avail, index) in dateList"
                                    :class="{ 'weekend-body': avail.isWeekend }"
                                    :key="'dateList1'+index"
                                  >
                                    <div class="body-wrapper special-price text-master-rate">
                                      <div
                                        class="vertical-divider"
                                        v-if="
                                          chid.roomRateSpecials.find(
                                            (x) => x.appliedDate == avail.date
                                          ) &&
                                          chid.roomRateSpecials.find(
                                            (x) => x.appliedDate == avail.date
                                          ).pricePax != -1
                                        "
                                      >
                                        <span class="fs-12 text-master-rate">{{
                                          numberFormat(
                                            chid.roomRateSpecials.find(
                                              (x) => x.appliedDate == avail.date
                                            ).pricePax
                                          )
                                        }}</span>
                                      </div>
                                      <div
                                        class="vertical-divider px-4 fs-12 text-master-rate"
                                        v-else
                                      >
                                        {{
                                          numberFormat(
                                            chid[formatDateOfWeekInPrice(avail.date)]
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </td>
                                  <td></td>
                                </tr>
                                <tr v-for="(restriction, idx1) in filterRestrictions" :key="'filterRestrictionsB'+idx1+'RC'+j1">
                                <td
                                  v-for="(avail, key) in dateList"
                                  :class="{ 'weekend-body': avail.isWeekend }"
                                  class="border-right"
                                  :key="'DL'+key"
                                >
                                  <div class="text-center">
                                      <span v-if="(rowData = chid.restrictionDTOS.find(e => e.appliedDate === avail.date))">
                                        <template v-if="['closed', 'closedOnArrival', 'closedOnDeparture'].includes(restriction.value)">
                                          <template v-if="rowData[restriction.value]">
                                            <i class="icon-Exit text-danger fs-18 font-weight-bold cursor-default"></i>
                                          </template>
                                          <template v-else>
                                          <i class="icon-check text-success fs-16 font-weight-bold cursor-default"></i>
                                          </template>
                                        </template>
                                        <template v-else>
                                          {{rowData[restriction.value] >= 0 ? rowData[restriction.value] : '-'}}
                                        </template>
                                      </span>
                                      <span v-else>-</span>
                                  </div>
                                </td>
                              </tr>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="text-center py-3" v-if="dataMasterRate.length == 0 && !isLoading">{{ $t("NO_DATA") }}</div>
            <v-col class="border-top">
              <ul class="tools-icon-description">
                <li>
                  <v-icon light size="18" color="#003e94" class="pr-1">edit</v-icon>
                  {{ $t("EDIT_PRICE") }}
                </li>
                <li>
                  <span class="txt-parent">M</span>
                  {{ $t("MASTER_PRODUCT") }}
                </li>
                <li>
                  <span class="txt-child-primary">C</span>
                  {{ $t("DERIVED_PRODUCT") }}
                </li>
                <li>
                  <b class="font-weight-bold">000</b>
                  {{ $t("SPECIAL_PRICE") }}
                </li>
              </ul>
            </v-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _alert } from "@/_helpers/function.js";
import DatePicker from "@/components/Utils/DatePicker.vue";

import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { syncota } from "@/_services/SyncOTA/syncota.js";

import moment from "moment";

//
import { masterRateService } from "@/_services/MasterRate/masterRate.service.js";

export default {
  components: {
    "date-picker": DatePicker,
  },
  data() {
    return {
      maxHeight: 430,
      weekend: ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"],
      defaultWeekend: [],
      dateList: [],
      listWeekend: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      currentDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
      selectedRoom: -1, // Phòng đang được sửa
      listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
      relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
      currentDate: moment().startOf("day").toDate(),
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
      listOTA: [],
      selectedOTA: null,
      selectedDatePicker: moment().startOf("day").format("YYYY-MM-DD"),

      // master rate
      ListProduceMaster: [],
      listProduce: [],
      selectedProduce: [],
      dataMasterRate: [],
      listRestriction: [
        {
          text: this.$t("minStay"),
          value: "minStay",
        },
        {
          text: this.$t("maxStay"),
          value: "maxStay",
        },
        {
          text: this.$t("minStayArrival"),
          value: "minStayArrival",
        },
        {
          text: this.$t("maxStayArrival"),
          value: "maxStayArrival",
        },
        {
          text: this.$t("minBookingWindow"),
          value: "minBookingWindow",
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "maxBookingWindow",
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "minBookingWindowByHour",
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "maxBookingWindowByHour",
        },
        {
          text: this.$t("exactStay"),
          value: "exactStay",
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exactStayArrival",
        },
        {
          text: this.$t("closedOnArrival"),
          value: "closedOnArrival",
        },
        {
          text: this.$t("closedOnDeparture"),
          value: "closedOnDeparture",
        },
        {
          text: this.$t("closed"),
          value: "closed",
        },
      ],
      selectedRestriction: []
    };
  },
  computed: {
    filterRestrictions() {
      return this.listRestriction.filter((e) => this.selectedRestriction.includes(e.value));
    }
  },
  created() {
    this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 75 - 20;
    this.getProduceMaster();
  },
  watch: {
    currentYear() {
      this.getRateCalendar(false);
    },
    selectedDatePicker() {
      this.currentDate = this.selectedDatePicker;
      this.getPriceProduce();
    },
  },
  methods: {
    getProduceMaster() {
      masterRateService.getProduceMaster().then((res) => {
        if (res.responseCode === 0) {
          this.ListProduceMaster = res.data;
          this.listProduce = res.data.map((e) =>
            Object.assign(
              {},
              {
                text:
                  e.roomTypeI18n.find((i) => i.lang === this.defaultI18n).name +
                  " - " +
                  e.ratePlanI18n.find((i) => i.lang === this.defaultI18n).name +
                  " - " +
                  e.otaI18n.find((i) => i.lang === this.defaultI18n).name,
                value: e.roomTypeId + '|' + e.ratePlanId,
              }
            )
          );
          if (this.listProduce.length > 0) {
            this.selectedProduce.push(this.listProduce[0].value);
          }
          this.getOtalist();
        }
      });
    },
    async getOtalist() {
      await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
        if (res.responseCode === 0) {
          this.listOTA = res.data.map((x) => {
            return {
              value: x.id,
              text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
              date: this.inDays(new Date(), new Date(x.endDate)),
              endDate: moment(x.endDate).format("DD/MM/YYYY HH:mm"),
            };
          });
          this.listOTA = this.listOTA.filter((x) => x.value);
          this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
          this.selectedOTA = localStorage.getItem("currentOTARoomSale")
            ? JSON.parse(localStorage.getItem("currentOTARoomSale"))
            : null;
          if (
            (this.listOTA.length > 0 &&
              this.listOTA[0].value &&
              this.selectedOTA == null) ||
            !this.listOTA.find((x) => x.value == this.selectedOTA)
          ) {
            this.selectedOTA = this.listOTA[0].value;
          } else {
          }

          this.getPriceProduce();
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    getPriceProduce() {
      this.isLoading = true;
      this.loadDateList();
      var fromDate = this.selectedDatePicker;
      var toDate = moment(this.selectedDatePicker).add(30, "day").format("YYYY-MM-DD");
      const ids =
        this.selectedProduce.length === 0
          ? []
          : this.selectedProduce.map(
              (ob) =>
                Object.assign(
                  {},
                  {
                    ratePlanId: ob.split('|')[1],
                    roomTypeId: ob.split('|')[0],
                  }
                )
            );
      const body = {
        from: fromDate,
        to: toDate,
        ids: [...ids],
        otaId: this.selectedOTA,
      };
      masterRateService
        .getPriceProduce(body)
        .then((res) => {
          if (res.responseCode === 0) {
            this.dataMasterRate = res.data;
            this.dataMasterRate.forEach(item => {
              item.otaName = '';
              let ota = this.listOTA.find(ota => item.otaId === ota.value);
              if (ota) {
                item.otaName = JSON.parse(JSON.stringify(ota.text));
              }
              if(item.children.length > 0) {
                item.children.forEach(child => {
                  child.otaName = '';
                  let ota = this.listOTA.find(ota => child.otaId === ota.value);
                  if (ota) {
                    child.otaName = JSON.parse(JSON.stringify(ota.text));
                  }
                })
              }
            });
          }
        })
        .finally(() => (this.isLoading = false));
    },
    updatePrice(item) {
    localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: item.roomTypeId,
          planId: item.ratePlanId,
          OtaId: item.otaId,
        })
      );
      this.$router.push({
        name: "priceUpdate",
      });
    },
    updateRestriction(room, meta) {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: room.roomTypeId,
          planId: room.ratePlanId,
          OtaId: room.otaId,
        })
      );
      this.$router.push({
        name: "restrictionUpdate",
        query: {
          metaData: meta,
        },
      });
    },
    onResize() {
      this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 70 - 20;
    },
    formatDateOfWeekInPrice(date) {
      let dayOfWeek;
      switch (moment(date).day()) {
        case 0: {
          dayOfWeek = "paxSunday";
          break;
        }
        case 1: {
          dayOfWeek = "paxMonday";
          break;
        }
        case 2: {
          dayOfWeek = "paxTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "paxWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "paxThursday";
          break;
        }
        case 5: {
          dayOfWeek = "paxFriday";
          break;
        }
        case 6: {
          dayOfWeek = "paxSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDate(date) {
      const currentDate = moment(date, "YYYY-MM-DD");
      if (!currentDate.isValid()) {
        return "";
      }
      let dayOfWeek = "";
      switch (currentDate.day()) {
        case 0: {
          dayOfWeek = this.$t("SUN_SHORT").toString();
          break;
        }
        case 1: {
          dayOfWeek = this.$t("MON_SHORT").toString();
          break;
        }
        case 2: {
          dayOfWeek = this.$t("TUE_SHORT").toString();
          break;
        }
        case 3: {
          dayOfWeek = this.$t("WED_SHORT").toString();
          break;
        }
        case 4: {
          dayOfWeek = this.$t("THU_SHORT").toString();
          break;
        }
        case 5: {
          dayOfWeek = this.$t("FRI_SHORT").toString();
          break;
        }
        case 6: {
          dayOfWeek = this.$t("SAT_SHORT").toString();
          break;
        }
      }
      return (
        '<div class="day-week">' +
        dayOfWeek +
        '</div><div class="day-day">' +
        currentDate.format("DD") +
        '</div><div class="day-month">' +
        this.$t(currentDate.format("MMM").toUpperCase() + "_SHORT") +
        "</div>"
      );
    },
    loadDateList() {
      let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
      // Chuyển từ binary sang select
      this.defaultWeekend = this.convertFromBinaryToListSelection(hotelWeekend);
      var tmp = [];
      this.defaultWeekend.forEach(function (element, index) {
        if (element == 1) {
          if (index == 0) {
            tmp.push("MON");
          }
          if (index == 1) {
            tmp.push("TUE");
          }
          if (index == 2) {
            tmp.push("WED");
          }
          if (index == 3) {
            tmp.push("THU");
          }
          if (index == 4) {
            tmp.push("FRI");
          }
          if (index == 5) {
            tmp.push("SAT");
          }
          if (index == 6) {
            tmp.push("SUN");
          }
        }
      });
      const currentDate = moment(this.currentDate);
      this.dateList = [];
      for (let i = 0; i < 31; i++) {
        const isWeekend = tmp.indexOf(currentDate.format("ddd").toUpperCase()) > -1;
        this.dateList.push({
          date: currentDate.format("YYYY-MM-DD"),
          isWeekend: isWeekend,
        });
        currentDate.add(1, "day");
      }
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    changeSearchCondition() {
      this.getPriceProduce();
      //   this.initialize(true);
    },
    nextMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(31, "day")
        .format("YYYY-MM-DD");
      this.initialize(true);
    },
    prevMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(-31, "day")
        .format("YYYY-MM-DD");

      if (this.selectedDatePicker < moment().startOf("day").format("YYYY-MM-DD")) {
        this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD");
      }

      this.initialize(true);
    },
    numberFormat(x) {
      if (x === 0) {
        return 0
      }
      if (x) {
        return new Intl.NumberFormat(this.systemLang, {
            style: 'decimal',
            minimumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
            maximumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
        }).format(x)
      }
    },
    _moment: moment,
  },
};
</script>

<style lang="scss" scoped>
.special-price + div {
  display: none;
}
.add-person {
  padding-left: 10px;
  z-index: 99999999;
}
.delete-person {
  padding-left: 10px;
  z-index: 99999999;
}
.copy-price {
  left: -8px;
  top: 8px;
  position: absolute;
  z-index: 99999999;
}
.tab-header {
  background-color: #fff;
  padding: 25px 15px 10px 15px;
}
.restriction-ota {
  font-size: 14px;

  h6 {
    font-size: 14px;
    &.room-title {
      background: #f0f0f0;
      padding: 10px;
      margin: 0;
      border-radius: 5px;
    }
  }
  .sale-package-info {
    align-items: center;
    border-bottom: 1px solid #dedddd;
    padding-bottom: 5px;
  }
  .col-md-12:last-child {
    .sale-package-info {
      border-bottom: none;
    }
  }
}
</style>
